import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function BenefitsSection() {
  return <section className="w-full bg-warm-dark-alt py-20 md:py-28 relative overflow-hidden" data-id="element-10">
      <div className="absolute top-0 left-0 w-[300px] h-[300px] bg-amber/[0.03] rounded-full blur-[80px] pointer-events-none" data-id="element-11" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-13">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-snug mb-4" data-id="element-14">
            Lo que vas a <span className="text-amber italic" data-id="element-15">lograr</span>
          </h2>
        </motion.div>

        <div className="space-y-5" data-id="element-16">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex items-start gap-4" data-id="element-17">
            <CheckCircleIcon className="w-6 h-6 text-amber flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-18" />
            <p className="font-body text-cream-muted/85 text-base sm:text-lg leading-relaxed" data-id="element-19">
              Recuperarás la energía y el equilibrio emocional.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex items-start gap-4" data-id="element-20">
            <CheckCircleIcon className="w-6 h-6 text-amber flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-21" />
            <p className="font-body text-cream-muted/85 text-base sm:text-lg leading-relaxed" data-id="element-22">
              Reducirás la ansiedad y el estrés con ejercicios simples.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex items-start gap-4" data-id="element-23">
            <CheckCircleIcon className="w-6 h-6 text-amber flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-24" />
            <p className="font-body text-cream-muted/85 text-base sm:text-lg leading-relaxed" data-id="element-25">
              Ganarás confianza a medida que integras nuevos hábitos sencillos
              en tu día a día.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex items-start gap-4" data-id="element-26">
            <CheckCircleIcon className="w-6 h-6 text-amber flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-27" />
            <p className="font-body text-cream-muted/85 text-base sm:text-lg leading-relaxed" data-id="element-28">
              Descubrirás oportunidades que antes no veías, a través de la
              visualización guiada.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="flex items-start gap-4" data-id="element-29">
            <CheckCircleIcon className="w-6 h-6 text-amber flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-30" />
            <p className="font-body text-cream-muted/85 text-base sm:text-lg leading-relaxed" data-id="element-31">
              Te sentirás más en control de tus emociones, logrando un
              equilibrio emocional duradero.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}